import store from '../redux/store';
import { logoutUser } from '../redux/actions/authActions'; 
import { Navigate } from 'react-router-dom';

export const apiService = async (url, options = {}) => {
    try {

        // Get access token from Redux store
        const accessToken = store.getState().auth.accessToken;

        // Add Authorization header if token exists
        if (accessToken) {
            options.headers = {
                ...options.headers,
                Authorization: `Bearer ${accessToken}`,
            };
        }

        // Make the API request
        const response = await fetch(url, options);

        if (response.status === 401) {
            console.warn('Token expired. Logging out user...');
            
            store.dispatch(logoutUser());

            return <Navigate to="/login" replace />;
        }

        if (!response.ok) {
            const responseData = await response.json();

            // Handle specific error from the API
            if (responseData.error === 'unknown_error' && responseData.message.includes('No user found')) {
                console.error("User not found error: ", responseData.message);
             
                return <Navigate to="/login" replace />;
            }

            throw new Error(`HTTP error! Status: ${response.status}, Message: ${responseData.message}`);
        }

        // Parse JSON response
        const responseData = await response.json();

        return responseData;
    } catch (error) {
        console.error("API error: ", error);
        // You can show a global error message here
        throw error;
    }
};
